var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-tags"},_vm._l((_vm._tags),function(tag,tagKey){return _c('div',{key:tagKey,staticClass:"ws-info-tag"},[_vm._v(_vm._s(tag))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }